// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import TuileRow from './TuileRow';
import ImageHeader from '../ImageHeader';
import { convertToPercentile, toFixedOrElse } from '../../../../utils/formatUtils';
import CurrencySurfaceConvertor from '../../../common/CurrencySurfaceConvertor';
import SurfaceConvertor from '../../../common/SurfaceConvertor';
import type { Store } from '../../../../types/apolloType';

type Props = {
  store: Store,
  sbrStorePercent: number,
}

function TuileMainRetailer(props: Props) {
  return (
    <div className="retailer">
      <ImageHeader score="100" retailer={props.store} />
      <div className="tile-row-container">
        <TuileRow
          legend="branchLevel"
          prefix={I18n.t('comparator.KPI.BL2')}
          label={props.store.bl2Name}
          isMainRetailer
        />
        <TuileRow
          legend="gla"
          prefix={I18n.t('comparator.KPI.GLA')}
          label={<SurfaceConvertor value={props.store.gla} isBold />}
          isMainRetailer
        />
        <TuileRow
          legend="erv"
          prefix={I18n.t('comparator.KPI.RRV')}
          label={
            <CurrencySurfaceConvertor
              value={toFixedOrElse(props.store.rrv, 2, 0)}
              withSymbol
              mustBeCurrencyBySurface
            />
          }
          isMainRetailer
        />
        <TuileRow
          legend="erv"
          prefix={I18n.t('comparator.KPI.TRV')}
          label={
            <CurrencySurfaceConvertor
              value={toFixedOrElse(props.store.trv, 2, 0)}
              withSymbol
              mustBeCurrencyBySurface
            />
          }
          isMainRetailer
        />
        <TuileRow
          legend="mgr"
          prefix={I18n.t('comparator.KPI.MGR')}
          label={
            <CurrencySurfaceConvertor
              value={toFixedOrElse(props.store.mgr, 2, null)}
              withSymbol
              mustBeCurrencyBySurface
            />
          }
          isMainRetailer
        />
        <TuileRow
          legend="sales"
          prefix={I18n.t('comparator.KPI.SALES')}
          label={
            <CurrencySurfaceConvertor
              value={toFixedOrElse(props.store.sales, 2, '')}
              withSymbol
              mustBeCurrencyBySurface
            />
          }
          isMainRetailer
        />
        <TuileRow
          legend="sbr"
          prefix={I18n.t('comparator.KPI.SBR')}
          label={
            <span>
              <CurrencySurfaceConvertor
                value={toFixedOrElse(props.store.sbr, 2, null)}
                withSymbol
                mustBeCurrencyBySurface
              />
              <small>
                {props.sbrStorePercent ? `(${props.sbrStorePercent.toFixed(2)} %)` : ''}
              </small>
            </span>
          }
          isMainRetailer
        />
        <TuileRow
          legend="sch"
          prefix={I18n.t('comparator.KPI.SCH')}
          label={
            <CurrencySurfaceConvertor
              value={toFixedOrElse(props.store.sch, 2, null)}
              withSymbol
              mustBeCurrencyBySurface
            />
          }
          isMainRetailer
        />
        <TuileRow
          legend="sbr"
          prefix={I18n.t('comparator.KPI.SCH_RETAILER')}
          label={
            <CurrencySurfaceConvertor
              value={toFixedOrElse(props.store.schRetailer, 2, 0)}
              withSymbol
              mustBeCurrencyBySurface
            />
          }
          isMainRetailer
        />
        <TuileRow
          legend="ocr"
          prefix={I18n.t('comparator.KPI.OCR')}
          label={convertToPercentile(props.store.ocr)}
          isMainRetailer
        />
        <TuileRow
          label="-"
          legend="foc"
          prefix={I18n.t('comparator.KPI.FOC')}
          isMainRetailer
        />
        <TuileRow
          label="-"
          legend="den"
          prefix={I18n.t('comparator.KPI.DEN')}
          isDark
          isMainRetailer
        />
        <TuileRow
          legend="roi"
          prefix={I18n.t('comparator.KPI.ROI')}
          label="-"
          isMainRetailer
        />
      </div>
    </div>
  );
}

export default TuileMainRetailer;
